import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { MIGRATE_ALL_STACKS_VENDOR } from "./gql";

const useMigrateAllStacksVendor = createDefaultMutationHook(MIGRATE_ALL_STACKS_VENDOR);

export default useMigrateAllStacksVendor;
